import { DomainLayout } from "@/components/layouts/DomainLayout";
import { AnalyticsView } from "../views/AnalyticsView";

export const AnalyticsPage = () => {
  return (
    <DomainLayout>
      <div className="[&_*]:border-0">
        <AnalyticsView />
      </div>
    </DomainLayout>
  );
};
